import { OrganizationList } from './components/OrganizationList';
import { UserCard } from './components/UserCard';
import { UserPaymentModelStatus } from './components/UserPaymentModelStatus';

export const Welcome = () => {
  return (
    <div className="w-full">
      <div className="border-[var(--color-divider)] border-t w-11/12 m-auto h-px pb-2" />
      <OrganizationList />

      <div className="pb-[15px]">
        <UserCard />
        <UserPaymentModelStatus />
      </div>
    </div>
  );
};
